import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Navbar from '../elements/Navbar';
import { Link } from 'react-router-dom';

const CATEGORIES = ['AI Updaters', 'Image Converter', 'Subscriptions',  'Storefront', 'Taxonomy'];

const KnowledgeBase = () => {
  const [articles, setArticles] = useState([]);
  const [search, setSearch] = useState('');
  const [category, setCategory] = useState('');
  const [loading, setLoading] = useState(true);

  const userEmail = localStorage.getItem('userEmail');
  const canEdit = userEmail === 'mario@getpop.co';

  const API_BASE = process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_API_URL_BASE_DEV
    : process.env.REACT_APP_API_URL_BASE_PROD;

  useEffect(() => {
    const fetchArticles = async () => {
      setLoading(true);
      try {
        const params = {};
        if (search) params.q = search;
        if (category) params.category = category;
        const res = await axios.get(`${API_BASE}/api/knowledge_base/articles`, { params });
        setArticles(res.data);
      } catch (e) {
        console.error('Failed to fetch articles:', e);
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
  }, [API_BASE, search, category]);

  return (
    <div>
      <Navbar />
      <div className="container mx-auto mb-32 px-4 max-w-4xl">
        <div className="flex justify-between items-start mb-8">
          <div>
            <h1 className="text-2xl font-semibold text-gray-900">Knowledge Base</h1>
            <p className="text-gray-500 mt-1 text-sm">
              Internal documentation for product taxonomy, services, and technical features.
            </p>
          </div>
          {canEdit && (
            <Link
              to="/knowledge-base/new"
              className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700 text-sm font-medium"
            >
              + New Article
            </Link>
          )}
        </div>

        <div className="flex gap-3 mb-6">
          <input
            type="text"
            placeholder="Search articles..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            className="border border-gray-300 rounded-md px-3 py-2 flex-1 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />
          <select
            value={category}
            onChange={e => setCategory(e.target.value)}
            className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
          >
            <option value="">All Categories</option>
            {CATEGORIES.map(c => (
              <option key={c} value={c}>{c}</option>
            ))}
          </select>
        </div>

        {loading ? (
          <p className="text-gray-400 text-sm">Loading...</p>
        ) : articles.length === 0 ? (
          <p className="text-gray-400 text-sm">No articles found.</p>
        ) : (
          <div className="space-y-3">
            {articles.map(article => (
              <Link
                key={article.slug}
                to={`/knowledge-base/${article.slug}`}
                className="block border border-gray-200 rounded-lg p-5 hover:border-indigo-400 hover:shadow-sm transition-all"
              >
                <div className="flex justify-between items-start">
                  <div>
                    {article.category && (
                      <span className="inline-block bg-indigo-50 text-indigo-600 text-xs font-medium px-2 py-0.5 rounded mb-1">
                        {article.category}
                      </span>
                    )}
                    <h2 className="text-base font-semibold text-gray-900">{article.title}</h2>
                    <p className="text-xs text-gray-400 mt-1">
                      {article.author && <span className="mr-3">{article.author}</span>}
                      <span>{new Date(article.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</span>
                    </p>
                  </div>
                  <span className="text-gray-300 text-lg">→</span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default KnowledgeBase;
